import React from 'react';
import { makeStyles } from '@mui/styles';
import {
  Container,
  Typography,
  Box,
} from '@mui/material';
import ContactForm from '../components/Contact/ContactForm.jsx';

const useStyles = makeStyles((theme) => ({
  pageHeader: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
    fontWeight: 700,
  },
  pageSubtitle: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
    maxWidth: '600px',
    margin: `0 auto ${theme.spacing(6)}`,
    lineHeight: 1.6,
  },
}));

const ContactPage = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 6 }}>
        <Typography variant="h2" className={classes.pageHeader}>
          Get in Touch
        </Typography>

        <Typography variant="h6" className={classes.pageSubtitle}>
          Have a question or want to connect? Drop me a message.
        </Typography>

        <ContactForm />
      </Box>
    </Container>
  );
};

export default ContactPage;
